import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import IndexPage from 'flarum/forum/components/IndexPage';
import ForumApplication from 'flarum/forum/ForumApplication';
import TextEditor from 'flarum/common/components/TextEditor';
import TextEditorButton from 'flarum/common/components/TextEditorButton';
import CamerasIndexPage from './components/CamerasIndexPage';
import CameraDetailPage from './components/CameraDetailPage';
import CameraPickerModal from './components/CameraPickerModal';
import { mountHoverCards } from './hoverCards';

app.initializers.add('acseven/chdk-cameras', () => {
  app.routes.cameras = { path: '/cameras', component: CamerasIndexPage };
  app.routes.camera = { path: '/cameras/:id', component: CameraDetailPage };

  // A muted twin of "Start a Discussion", directly under it. sidebarItems
  // (not navItems) is what holds that button. Core adds BOTH 'newDiscussion'
  // and 'nav' with no priority argument, i.e. 0, so no priority can land
  // between them -- ours also goes in at 0 (after both, insertion order) and
  // the nav list is pushed below it instead.
  extend(IndexPage.prototype, 'sidebarItems', (items) => {
    items.add(
      'cameras',
      <LinkButton
        href={app.route('cameras')}
        icon="fas fa-camera"
        className="Button Button--block CamerasNavButton"
      >
        {app.translator.trans('acseven-chdk-cameras.forum.header.cameras')}
      </LinkButton>
    );

    items.setPriority('nav', -100);
  });

  extend(TextEditor.prototype, 'toolbarItems', function (items) {
    if (!this.attrs.composer) return;

    items.add(
      'chdk-cameras',
      <TextEditorButton
        icon="fas fa-camera"
        title={app.translator.trans('acseven-chdk-cameras.forum.composer.camera_button')}
        onclick={() => app.modal.show(CameraPickerModal, { editor: this.attrs.composer.editor })}
      />
    );
  });

  mountHoverCards();

  // Admin can turn the dashed "provisional link" underline off (default on).
  // Core's boot() runs every initializer BEFORE it pushes the payload into
  // the store and assigns app.forum, so reading the attribute here throws
  // "Cannot read properties of undefined" and the whole initializer dies.
  // mount() runs after, which is the earliest app.forum exists.
  extend(ForumApplication.prototype, 'mount', () => {
    if (app.forum.attribute('chdkCamerasProvisionalUnderline') === false) {
      document.documentElement.classList.add('chdk-cameras-no-provisional');
    }
  });
});
